import Script from 'next/script';
import useMatchMedia from '@/hooks/useMatchMedia';
import PageHead from '@/components/common/PageHead';

import Container from '@/components/common/Container';
import Section from '@/components/common/Section';
import Heading from '@/components/common/Heading';
import ClientOnly from '@/components/common/ClientOnly';
import Box from '@/components/common/Box/Box';

import ServicesIntroduction from '@/components/Pages/Services/ServicesIntroduction';
import ServicesLayout from '@/components/Pages/Services/ServicesLayout';
import ServicesBlock from '@/components/Pages/Services/ServicesBlock';
import Info from '@/components/Pages/Index/Info';
import FAQs from '@/components/Pages/Index/FAQs';
import InnerHero from '@/components/InnerHero/InnerHero';
import BackgroundHero from '@/components/common/Background/BackgroundHero';

import webdesignBlock from '@/db/services/hosting/hostingBlock.json';
import faqs from '@/db/services/hosting/hostingFaq.json';
import info from '@/db/services/hosting/hostingInfo.json';
import innerHero from '@/db/services/hosting/hostingHero.json';
import introduction from '@/db/services/hosting/hostingIntroduction.json';

import hostingMeta from '@/db/services/hosting/hostingMeta.json';
import ss_hosting from '@/db/seoscript/ss_hosting.json';

const Hosting = () => {
  const { isMobile } = useMatchMedia();
  return (
    <>
      <PageHead {...hostingMeta} />

      <Box className=" relative">
        <Container>
          <Section className="pt-0 pb-0 lg:pb-4">
            <InnerHero innerHero={innerHero} />
          </Section>
        </Container>
        <BackgroundHero />
      </Box>

      <Container>
        <Section className=" lg:mx-[150px]">
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16  ">
            Migration and Upgrade
          </Heading>
          <ServicesIntroduction introduction={introduction} />
        </Section>
      </Container>

      <Container>
        <Section>
          <ServicesBlock webdesignBlock={webdesignBlock} />
        </Section>
      </Container>

      <Container>
        <Section className="px-0 md:px-[50px]">
          <Heading headingLevel="h2" className=" text-center mb-5 md:mb-16">
            Seamlessly Migrate and Upgrade Your Website with Our Expertise
          </Heading>
          <Info info={info} />
        </Section>
      </Container>

      <Container>
        <Section>
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16">
            <ClientOnly>
              {isMobile ? 'FAQs' : 'Frequently Asked Questions'}
            </ClientOnly>
          </Heading>
          <FAQs faqs={faqs} />
        </Section>
      </Container>

      <Script
        id="ss_hosting"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ss_hosting) }}
      />
    </>
  );
};

Hosting.PageLayout = ServicesLayout;

export default Hosting;
